export var SET_PENDING_REQUESTS = 'SET_PENDING_REQUESTS';
export var REMOVE_FROM_PENDING_REQUESTS = 'REMOVE_FROM_PENDING_REQUESTS';
export var CLEAR_PENDING_REQUESTS = 'CLEAR_PENDING_REQUESTS';
